<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical headerTitle="91.5 Item List Follow Up" :useBtnList="[
                    'btnRetrieve', //Retrieve
                    'btnExcel'
                ]" @btnRetrieve="btnRetrieve()" @btnExcel="btnExcel()">
                    <template v-slot:body>
                        <v-layout column overflow-auto>
                            <v-row dense>
                                <v-col cols="12" class="pa-0">
                                    <i-card-top class="d-md-flex" outlined>
                                        <template v-slot:body>
                                            <v-layout column>
                                                <v-row no-gutters class="center pa-2 pb-2">
                                                    <v-icon small color="blue" class="pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Ship no : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="selectedShip" :items="shipNoList"
                                                            item-value="selectedShip" label="" return-object single-line
                                                            outlined dense @change="shipNoChange"></v-select>
                                                    </v-col>
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Por no : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="selectedPor" :items="porList"
                                                            item-value="selectedPor" return-object single-line outlined
                                                            dense :label="'All'" @change="btnRetrieve()"></v-select>
                                                    </v-col>
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Block : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="selectedBlock" :items="blockList"
                                                            item-value="selectedBlock" return-object single-line
                                                            outlined dense :label="'All'"
                                                            @change="btnRetrieve()"></v-select>
                                                    </v-col>
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 subTitle"> Warehouse Div : </span>
                                                    <v-col cols="1">
                                                        <v-select v-model="whDiv.select" :items="whDiv.items" item-text="name" item-value="cd" return-object single-line
                                                            outlined dense />
                                                    </v-col>
                                                </v-row>
                                                <v-row dense class="ma-0">
                                                    <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                    <span class="pa-1 pt-2 subTitle">Duration by : </span>
                                                    <v-col cols="2">
                                                        <v-select v-model="reqDiv.select" :items="reqDiv.items"
                                                            item-text="name" item-value="cd" return-object single-line
                                                            outlined dense />
                                                    </v-col>
                                                    <v-col cols="2">
                                                        <DxDateBox :value="startDate" height="30px"
                                                            display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                            @value-changed="e => { reqDtFrom = e.value && getStrFormat(e.value) }" />
                                                    </v-col>
                                                    <span class="pa-1 pt-2 subTitle"> ~ </span>
                                                    <v-col cols="2">
                                                        <DxDateBox :value="endDate" height="30px"
                                                            display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                                            @value-changed="e => { reqDtFrom = e.value && getEndFormat(e.value) }" />
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                        </template>
                                    </i-card-top>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0">
                                    <DxDataGrid id="epms9062" class="listBox" :ref="epms9062Ref"
                                        :data-source="gridMainList" :remote-operations="false"
                                        :hover-state-enabled="true" :allow-column-resizing="true"
                                        :allow-column-reordering="true" :row-alternation-enabled="true"
                                        :show-borders="true" :width="grid.width" :show-row-lines="true" key-expr="id"
                                        :focused-row-enabled="true" :column-hiding-enabled="false"
                                        :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }"
                                        :word-wrap-enabled="true" @cellPrepared="cellPrepared">

                                        <DxColumn data-field="rnum" caption="No" width="7%" data-type="string"
                                            :allow-editing="false" alignment="center" />

                                        <DxColumn data-field="shipNo" caption="Ship No" width="8%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true"/>
                                        
                                        <DxColumn data-field="block" caption="Block" width="7%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" />

                                        <DxColumn data-field="stageCd" caption="Stage" width="8%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" />

                                        <DxColumn  caption="Por No" width="15%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" >
                                            <DxColumn data-field="porNo" caption="Item Name" width="15%" data-type="string" :allow-editing="false" alignment="center"
                                            :visible="true" cell-template="porNoTemplate" />
                                        </DxColumn>

                                        <template #porNoTemplate="{ data }">
                                            <div>
                                                <div v-if="data.rowIndex % 2 == 0">
                                                    <v-btn small elevation="0" color="transparent" class="px-0 py-0 my-auto grd-btn" @click.stop="drawingPage($event)">
                                                        {{ data.value.slice(0,8) }}
                                                    </v-btn>-{{ data.value.slice(9,11) }}
                                                </div>
                                                <div v-else>
                                                    {{ data.value }}
                                                </div>                                                                                               
                                            </div>
                                            
                                        </template>                                                                                

                                        <DxColumn  caption="Part No" width="12%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="partNo" caption="Item Name" width="12%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" />
                                        </DxColumn>

                                        <DxColumn  caption="BOM Qty" width="8%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true" header-cell-template="BOM">
                                            <DxColumn data-field="partUnitWgt" caption="BOM Wgt" width="8%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" header-cell-template="BOMwgt" />
                                        </DxColumn>
                                        <template #BOM>
                                            <div>BOM<br />Qty</div>
                                        </template>
                                        <template #BOMwgt>
                                            <div>BOM<br />Wgt</div>
                                        </template>
                                        <DxColumn data-field="whQty" caption="WH Qty" width="8%" data-type="string"
                                            :allow-editing="false" alignment="right" :visible="true">
                                            <DxColumn data-field="whWgt" caption="WH Wgt" width="8%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" />
                                        </DxColumn>                                        

                                        <DxColumn data-field="nyQty" caption="NotYet W/H Qty" width="16%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true"
                                            header-cell-template="notWhQty" >                                           
                                            <DxColumn data-field="delyQty" caption="Dely Qty" width="8%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" header-cell-template="deliQty"/>
                                            <DxColumn data-field="delyWgt" caption="Dely Wgt" width="8%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" header-cell-template="deliWgt"/>
                                        </DxColumn>

                                        <template #notWhQty>
                                            <div>NotYet W/H<br />Qty</div>
                                        </template>
                                        <template #deliQty>
                                            <div>Dely<br />Qty</div>
                                        </template>
                                        <template #deliWgt>
                                            <div>Dely<br />Wgt</div>
                                        </template>

                                        <DxColumn data-field="nyWgt" caption="NotYet W/H Wgt" width="16%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true" header-cell-template="notWhWgt">
                                            <DxColumn data-field="ndelyQty" caption="NDely Qty" width="8%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" header-cell-template="nDeliQty" />
                                            <DxColumn data-field="ndelyWgt" caption="NDely Wgt" width="8%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true" header-cell-template="nDeliWgt" />
                                        </DxColumn>
                                        
                                        <template #notWhWgt>
                                            <div>NotYet W/H<br />Wgt</div>
                                        </template>
                                        <template #nDeliQty>
                                            <div>NDely<br />Qty</div>
                                        </template>
                                        <template #nDeliWgt>
                                            <div>NDely<br />Wgt</div>
                                        </template>

                                        <DxColumn data-field="inPntCd"  caption="Paint Code" width="8%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true"
                                            header-cell-template="PaintCode"/>                                           

                                        <template #PaintCode>
                                            <div>Paint<br />Code</div>
                                        </template>

                                        <DxColumn data-field="quotNo" caption="Quot No" width="12%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="delyNo" caption="Dely No" width="12%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" />
                                        </DxColumn>
                                        
                                        <DxColumn data-field="psdDt" caption="Material Need Date" width="10%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" header-cell-template="needDate"/>
                                        
                                        <template #needDate>
                                            <div>Material<br />Need Date</div>
                                        </template>

                                        <DxColumn data-field="reqDte" caption="Req.Iss.DT" width="10%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="issueDt" caption="Iss.Date" width="10%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Make Start" width="10%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="stMakeDte" caption="Make Finish" width="10%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" />
                                        </DxColumn>

                                        <DxColumn caption="Pain Start" width="10%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true">
                                            <DxColumn data-field="stPaintDte" caption="Pain Finish" width="10%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" />
                                        </DxColumn>

                                        <DxColumn data-field="hndQty" caption="Hnd Qty" width="8%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" header-cell-template="hndQty">
                                            <DxColumn data-field="hndWgt" caption="Hnd Wgt" width="8%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" header-cell-template="hndWgt"/>
                                        </DxColumn>
                                        
                                        <template #hndQty>
                                            <div>Hnd<br />Qty</div>
                                        </template>
                                        <template #hndWgt>
                                            <div>Hnd<br />Wgt</div>
                                        </template>

                                        <DxColumn data-field="delyLoc" caption="Dely Loc" width="15%" data-type="string"
                                            :allow-editing="false" alignment="center" :visible="true" >
                                            <DxColumn data-field="reqLocNo" caption="Req. Loc" width="15%"
                                                data-type="string" :allow-editing="false" alignment="center"
                                                :visible="true" />
                                        </DxColumn>

                                        <DxPaging :enabled="true" :page-size="18" />
                                    </DxDataGrid>
                                </v-col>
                            </v-row>
                        </v-layout>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>
        <drawingPagePop v-if="showPop" :showPop.sync="showPop" :gbn="'POR'" :paramNo="dwgPorNo" />
    </v-container>
</template>

<script>
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import drawingPagePop from '@/views/hip/common/drawingPagePop'
import { epms9062List, epms9062Xls } from '@/api/view/hip/91/epms9062.js'
import { getShipNoList1, epms9000_block, epms9000_por_no } from '@/api/view/hip/common/common.js'
import { getDateFormat } from '@/utils/common.js'
import DxDateBox from 'devextreme-vue/date-box'
import { getNumComma } from '@/utils/common.js'

export default {
    name: 'epms9062',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        'i-card-top': iCardTop,
        DxDateBox,
        drawingPagePop
    },
    data() {
        return {
            gridMainList: [],
            epms9062Ref: "epms9062Ref",
            selectedShip: '',
            shipNoList: [],

            selectedPor: 'All',
            porList: [],

            selectedBlock: 'All',
            blockList: [],

            startDate: '',
            endDate: '',

            stDte: '',
            edDte: '',

            showPop: false,
            dwgPorNo: '',

            whDiv: {
                select: { name: 'All', cd: '0' },
                items: [
                    { name: 'All', cd: '0' },
                    { name: 'Warehouse', cd: '1' },
                    { name: 'NotYet WareHouse', cd: '2' },
                    { name: 'NotYet Make Dely Note', cd: '3' }
                ]
            },

            reqDiv: {
                select: { name: 'Material Need Date', cd: '0' },
                items: [
                    { name: 'Material Need Date', cd: '0' },
                    { name: 'Request Issue', cd: '1' }
                ]
            }
        }
    },
    computed: {
        gridMainInstance() {
            return this.GetDataGrid(this.epms9062Ref)
        },
    },
    methods: {
        getStrFormat(date) {
            this.stDte = getDateFormat(date)
            return getDateFormat(date)
        },
        getEndFormat(date) {
            this.edDte = getDateFormat(date)
            return getDateFormat(date)
        },
        formatPrice(value) {
            return getNumComma(value)
        },
        drawingPage(e) {

            let porNo = e.srcElement.innerText

            this.dwgPorNo = porNo.slice(0, 8)

            console.log(this.dwgPorNo)

            this.showPop = true
        },
        shipNoChange(e) {

            this.porList = [],
                this.blockList = [],

                this.getPorList()
            this.getBlockList()

        },

        btnRetrieve() {
            if (!this.selectedShip) {
                this.vToastify(this.$t('Ship no is not selected.'), 'warn')
                return
            }

            this.doSearchMain()
        },
        async doSearchMain() {

            this.openLoading('searching')
            let params = {
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip,
                porNo: this.selectedPor === 'All' ? '' : this.selectedPor,
                block: this.selectedBlock === 'All' ? '' : this.selectedBlock,
                whDiv: this.whDiv.select.cd,
                reqDiv: this.reqDiv.select.cd,
                stDte: this.stDte,
                fiDte: this.edDte
            }

            await epms9062List(params).then(res => {
                //this.gridMainList = res.list
                let list = []
                let cnt = 1;
                res.list.forEach(e => {
                    list.push(
                        {
                            id: cnt++, rnum: e.rnum, shipNo: e.shipNo, block: e.block, stageCd: e.stageCd, porNo: e.porNo + '-' + e.porSeq, partNo: e.partNo,
                            partUnitWgt: e.partQty,     whWgt: e.whQty,  delyQty: e.nyQty,  delyWgt: e.nyQty,   ndelyQty: e.nyWgt,   ndelyWgt: e.nyWgt,    inPntCd: e.inPntCd,  delyNo: e.quotNo,
                            psdDt: e.psdDt, reqDte: e.reqDte, stMakeDte: e.stMakeDte, stPaintDte: e.stPaintDte, hndWgt: e.hndQty, reqLocNo: e.delyLoc
                        },
                        {
                            id: cnt++, rnum: e.rnum, shipNo: e.shipNo, block: e.block, stageCd: e.stageCd, porNo: e.matlSpec, partNo: e.matlSpec,
                            partUnitWgt: e.partUnitWgt, whWgt: e.whWgt, delyQty: e.delyQty, delyWgt: e.delyWgt, ndelyQty: e.ndelyQty, ndelyWgt: e.ndelyWgt, inPntCd: e.outPntCd, delyNo: e.delyNo,
                            psdDt: e.psdDt, reqDte: e.issueDt, stMakeDte: e.edMakeDte, stPaintDte: e.edPaintDte, hndWgt: e.hndWgt, reqLocNo: e.reqLocNo
                        },
                    )
                });
                this.gridMainList = list
                

            }).finally(() => {
                //console.log(this.gridMainList);
                this.endLoading();
            })
        },

        async getShipNoList() {
            let params = {
                makerCd: this.$store.state.user.makerCd
            }

            await getShipNoList1(params).then(res => {
                res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                });
            })
        },

        async getPorList() {
            let params = {
                incNotPo: 'Y',
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip
            }

            await epms9000_por_no(params).then(res => {
                this.porList.push('All')
                res.list.forEach(e => {
                    this.porList.push(e.porNo)
                });
            })
        },

        async getBlockList() {
            let params = {
                incNotPo: 'Y',
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip
            }

            await epms9000_block(params).then(res => {
                this.blockList.push('All')
                res.list.forEach(e => {
                    this.blockList.push(e.block)
                });
            })
        },

        btnExcel() {
            this.openLoading('Saving Excel!')
            let params = {
                makerCd: this.$store.state.user.makerCd,
                shipNo: this.selectedShip,
                porNo: this.selectedPor === 'All' ? '' : this.selectedPor,
                block: this.selectedBlock === 'All' ? '' : this.selectedBlock,
                whDiv: this.whDiv.select.cd,
                reqDiv: this.reqDiv.select.cd,
                stDte: this.stDte,
                fiDte: this.edDte
            }

            epms9062Xls(params).finally(() => {
                this.endLoading();
            })

        },
        //cell merge
        cellPrepared(e) {
            if (e.rowType === 'data') {
                if (e.column.caption === 'No' || e.column.caption === 'Ship No' || e.column.caption === 'Block' || e.column.caption === 'Stage'   || e.column.caption === 'Material Need Date') {
                    if (e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'rnum')) {
                        e.cellElement.setAttribute('rowspan', 2)
                    } else {
                        e.cellElement.style.display = 'none'
                    }                    
                }
                console.log(e)

                if (e.column.name === 'partUnitWgt') {
                    e.cellElement.style.backgroundColor = "#B6D3F0"
                }
                if (e.column.name === 'whWgt') {
                    e.cellElement.style.backgroundColor = "#C6D3A0"
                }
                if (Number(e.rowIndex) % 2 === 0) {
                    if (e.column.caption === 'Dely Qty') {
                        e.cellElement.setAttribute('colspan', 2)
                        e.cellElement.style.backgroundColor = "#D2D3A0"
                    } else if (e.column.caption === 'Dely Wgt') {
                        e.cellElement.style.display = 'none'
                    } else if (e.column.caption === 'NDely Qty') {
                        e.cellElement.setAttribute('colspan', 2)
                        e.cellElement.style.backgroundColor = "#D2D3A0"
                    } else if (e.column.caption === 'NDely Wgt') {
                        e.cellElement.style.display = 'none'
                    } 
                } else {
                    if (e.column.caption === 'Dely Qty' || e.column.caption === 'Dely Wgt' ) {                       
                        e.cellElement.style.backgroundColor = "#B1D3D0"
                    } else if (e.column.caption === 'NDely Qty' || e.column.caption === 'NDely Wgt') {                      
                        e.cellElement.style.backgroundColor = "#A3A3B0"
                    } 
                }
                
                //console.log(e)
                if (e.column.caption === 'Item Name' && Number(e.rowIndex) % 2 !== 0) {
                    
                   if(e.columnIndex === 4){
                       e.cellElement.setAttribute('colspan', 2)
                   }else if (e.columnIndex === 5){
                       e.cellElement.style.display = 'none'
                   }
                   //e.column.cellTemplate = 'none'
                }

            } else {
                if (e.column.caption === 'Item Name' && e.columnIndex === 0) {                    
                    e.cellElement.setAttribute('colspan', 2)
                    } else if (e.column.caption === 'Item Name' && e.columnIndex === 1) {
                        e.cellElement.style.display = 'none'
                    } 
                }
            }

        },
        mounted() {
            var date = new Date();
            this.startDate = new Date(date.getFullYear(), 0, 1)
            this.endDate = new Date(date.getFullYear(), date.getMonth() + 2, 0);


            this.getShipNoList()
            this.gridMainInstance.option('defaultPaging', false)
        }
    }

</script>

<style scoped>

</style>